import { Web3Farm__factory, Web3FarmV2__factory } from '@shared/config/contracts/abi-typed';

export enum FarmContractVersion {
  V1 = '1.0',
  V2 = '2.0',
}

type FarmPoolAbiMap = {
  [FarmContractVersion.V1]: typeof Web3Farm__factory.abi;
  [FarmContractVersion.V2]: typeof Web3FarmV2__factory.abi;
};

export const FARM_CONTRACT_BY_VERSION: FarmPoolAbiMap = {
  [FarmContractVersion.V1]: Web3Farm__factory.abi,
  [FarmContractVersion.V2]: Web3FarmV2__factory.abi,
};
